import { AuditStatusDetailType } from '@/const/status';
import { NovelState } from '@/services/novel';

import { IStory } from './module';
import { CollectionSortType } from './promotion';

export enum NovelHomeType {
  APP = 0,
  QQ_VIDEO = 1,
  TEENAGER_GUARDIAN = 2,
}

export enum NovelHomeItemType {
  HOMEDATAITEMTYPE_MULTICOLLECTION = 1
}

export enum SubCollectionType {
  DEFAULT = 0,
  NOVEL = 1,
  AVG = 2,
}

export interface INovel {
  novelId: string;
  novelName: string;
  coverUrl?: {
    url: {
      url: string;
    };
  };
  updatedTime?: string,
  auditStatus?: AuditStatusDetailType;
  novelInspiration?: string;
  authorInfo: {
    id: string;
  },
  state?: NovelState;
}

export interface ISubCollection {
  name: string;
  desc: string;
  sortType: CollectionSortType;
  type: SubCollectionType;
  novels: INovel[];
  stories: IStory[];
}

export interface INovelHomeItem {
  id: string;
  homeDataId: string;
  showIndex: number;
  type: NovelHomeItemType;
  multiCollection?: ISubCollection[];
}

export interface INovelHome {
  id: string;
  name: string;
  isUsed: boolean;
  createdTime: string;
  updatedTime: string;
  updatedBy: string;
  type: NovelHomeType;
  itemList: INovelHomeItem[];
  twoColumnLayout: { novels: INovel[] };
}
